import { sliderAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
export { Slider, SliderTrack, SliderThumb, SliderFilledTrack } from "@chakra-ui/react";
const baseStyleThumb = {
    borderRadius: 'rounded',
    borderColor: 'border.neutral.primary.default',
    borderStyle: 'solid',
    borderWidth: 's',
    color: 'background.accent.onDark.default',
    height: '12px',
    width: '12px',
    _dark: {
        borderColor: 'border.neutral.primary.default',
        color: 'background.accent.onDark.default'
    }
};
const baseStyleTrack = ()=>{
    return {
        borderRadius: 'rounded',
        bg: 'background.neutral.tertiary.default',
        _dark: {
            bg: 'background.neutral.tertiary.default'
        }
    };
};
const baseStyleFilledTrack = ()=>{
    return {
        borderRadius: 'rounded',
        bg: 'background.accent.primary.default',
        _dark: {
            bg: 'background.accent.primary.default'
        }
    };
};
const baseStyle = (props)=>({
        thumb: baseStyleThumb,
        track: baseStyleTrack(props),
        filledTrack: baseStyleFilledTrack(props)
    });
const sizes = {
    small: defineStyle((props)=>({
            track: props.orientation === 'horizontal' ? {
                h: '2px'
            } : {
                w: '2px'
            }
        })),
    medium: defineStyle((props)=>({
            track: props.orientation === 'horizontal' ? {
                h: '4px'
            } : {
                w: '4px'
            }
        }))
};
export const ThemedSlider = defineMultiStyleConfig({
    sizes,
    baseStyle,
    defaultProps: {
        size: 'medium'
    }
});

//# sourceMappingURL=index.js.map